<template>
    <div class="module-afiliasi">
        <SOSlotBase :container-name="'terms-page-content'" :loading="!formReady">
            <template v-slot:title-bar>
              <div>
                <SOTitleBar :page-title="'Afiliasi'" :type="'back'" @back="back"/>
              </div>
            </template>
            <template v-slot:loading-page>
              <div>
                <SOLoadingPage/>
              </div>
            </template>

            <template v-slot:content>
                <div class="afiliasi-dashboard p-x-20" v-if="formReady">
                    <div class="referal-link d-grid-1 items-centered">
                        <label class="m-d-12 f-16 f-semi f-c-black gc-1">Bagikan link referral anda</label>
                        <div class="link gc-1">
                            <img src="@/assets/img/link-blue.svg" alt=""/>
                            <label class="f-14 f-regular f-c-blue">{{ referalLink }}</label>
                            <input type="hidden" id="referal_link" :value="referalLink"/>
                        </div>
                        <div class="m-t-12 actions-link items-centered d-grid-2">
                            <SOButton :outline="true" :full="true" :text="'Salin'" :id="`afiliasi-Salin`"
                                      @action="copyLink"/>
                            <SOButton :primary="true" :full="true" :text="'Bagikan'" :id="`afiliasi-Bagikan`"
                                      @action="shareLink"/>
                        </div>
                    </div>

                    <div class="separator m-t-12 m-d-12 m-x-min"></div>

                    <div class="cash d-grid-2">
                        <div class="gc-1">
                            <div>
                                <label class="f-c-midgrey f-14 f-regular m-d-0">Dompet Afiliasi</label>
                            </div>
                            <div>
                                <label class="f-bold m-d-0 f-18 f-c-black">{{ saldo | currency }}</label>
                            </div>
                        </div>
                        <div class="gc-1 j-self-end" :class="isOffCash ? 'cash-disabled' : 'cash-active'">
                            <div id="btn-afiliasi-withdraw">
                                <SOButton
                                        :outline="true"
                                        :full="true"
                                        :text="cashLabel"
                                        :id="`afiliasi-withdraw`"
                                        :disable="isOffCash"
                                        @action="doWithdraw"
                                        @hook:mounted="onMounted"
                                />
                            </div>
                        </div>
                        <div class="gc-2">
                            <div class="note">  <img src="@/assets/icons/alert-circle-blue.svg" alt=""/>
                                <label class="f-12 f-c-blue f-regular m-d-0">
                                    Anda dapat melakukan tarik tunai <br/> <b>Hanya pada tanggal 1 s/d 4 Disetiap awal Bulan</b></label>
                            </div>
                        </div>
                    </div>

                    <div class="separator-line m-d-12 m-x-min"></div>

                    <div class="withdraw" v-if="lastWithdraw.length > 0">
                        <div>
                            <label class="f-14 f-c-midgrey f-regular m-d-8">Pencairan Aktif</label>
                        </div>
                        <div>
                            <SOCardTarikTunai :card-type="`box`" :data-transaksi="lastWithdraw"
                                              :withdraw-status="defaultStatus"/>
                        </div>
                    </div>

                    <div class="separator m-t-12 m-d-12 m-x-min"></div>

                    <div class="detail-link">
                        <div v-for="(menu, key) in subMenuList" :key="`afiliasi-subMenu${key}`" class="sub-menu-list">
                            <SOMenuItemRegular
                                    :show-subtitle="true"
                                    :title="menu.title"
                                    :subtitle="menuSubTitle(menu)"
                                    icon-color="grey"
                                    @detail="linkToDetail(menu)"
                                    @hook:mounted="whenUnsetBank(menu)"
                            >
                            </SOMenuItemRegular>
                            <div class="menu-separator m-x-min"></div>
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";

    import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
    import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
    import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
    import SOButton from "@/so-components/global/ui/SOButton";
    import SOMenuItemRegular from "@/so-components/global/ui/SOMenuItemRegular";

    import SOCardTarikTunai from "../components/SOCardTarikTunai.vue";
    import {moduleName, menuDetail} from "../store/state";
    import withdrawStatus from "../static/withdrawStatus";

    export default {
        name: "DashboardPage",
        components: {
            SOSlotBase,
            SOTitleBar,
            SOButton,
            SOMenuItemRegular,
            SOCardTarikTunai,
            SOLoadingPage,
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (from.name === "afiliasi.dashboard.make_withdraw") {
                    vm.isFromWD = true;
                }
            });
        },
        async mounted() {
            await this.init();
            await this.setFormReady(false);
            this.smartTrackingView("afiliasi");

        },
        data() { 
            return {
                emptyRekening: "Rekening pencairan belum diisi",
                cashLabel: "Cairkan",
                isOffCash: false,
                formReady: false,
                isFromWD: false,
            };
        },
        watch: {
            withdrawStatus: function (newStatus, oldStatus) {
                if (newStatus !== oldStatus) {
                    if (newStatus !== withdrawStatus.do) {
                        this.isOffCash = false;
                        this.cashLabel = "Cairkan";
                    } else {
                        this.isOffCash = true;
                        this.cashLabel = "Dalam Proses";
                    }
                }
            },
            afiliasiSet: function (newASet, oldASet) {
                if (newASet.rekening.noRekening && newASet.rekening.noRekening !== oldASet.rekening.noRekening) {
                    this.whenUnsetBank({id: 2});
                }
            },
            getResponse: function (newRes, oldRes) {
                if (newRes.success) {
                    this.setFormReady(true);
                }

                if (newRes !== oldRes) {
                    if (oldRes.success && this.isFromWD) {
                        this.$toast.success(oldRes.msg);
                        this.isFromWD = false;
                    }
                }
            },
        },
        computed: {
            ...mapGetters(moduleName, {
                response: "getResponse",
                isFetching: "isFecthing",
                afiliasiSet: "afiliasiSet",
                lastWithdraw: "lastWithdraw",
                getResponse: "getResponse",
                totalWithdraw: "totalWithdraw"
            }),
            defaultStatus() {
                return withdrawStatus;
            },
            withdrawStatus() {
                let wdStat = withdrawStatus.idle;
                if (this.lastWithdraw.length > 0) {
                    switch (this.lastWithdraw[0].status) {
                        case 0:
                            wdStat = withdrawStatus.do;
                            break;
                        case 1:
                            wdStat = withdrawStatus.success;
                            break;
                        case 2:
                            wdStat = withdrawStatus.reject;
                            break;
                        default:
                            wdStat = withdrawStatus.idle;
                            break;
                    }
                }
                return wdStat;
            },
            referalLink() {
                return this.afiliasiSet.referalLink;
            },
            saldo() {
                return this.afiliasiSet.saldo;
            },
            subMenuList() {
                return menuDetail;
            },
            menuSubTitle() {
                return (menu) => {
                    let subTitle = menu.subTitle;
                    let {namaBank, noRekening, pemilik} = this.afiliasiSet.rekening;
                    let {totalTeman, totalOutlet} = this.afiliasiSet.afiliated;

                    if (menu.id === 2) {
                        if (namaBank) {
                            subTitle = `${namaBank} - ${noRekening} (${pemilik})`;
                        } else {
                            subTitle = this.emptyRekening;
                        }
                    }

                    if (menu.id === 4) {
                        if (totalTeman) {
                            subTitle = `${totalOutlet} outlet aktif dari ${totalTeman} teman yang bergabung`;
                        }
                    }

                    if (menu.id === 3) {
                      if (this.totalWithdraw) {
                        subTitle = `Total pencairan selama ini Rp ${this.totalWithdraw.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\.")}`
                      }
                    }

                    return subTitle;
                };
            },
        },
        methods: {
            ...mapActions({
                getAfiliasi: `${moduleName}/getAfiliasi`,
            }),
            onMounted() {
                let btn = document.getElementById("btn-afiliasi-withdraw").childNodes[0].childNodes[0];

                btn.style.padding = "4px";
            },
            whenUnsetBank(menu) {
                if (menu.id === 2) {
                    if (!this.afiliasiSet.rekening.namaBank) {
                        document
                            .getElementsByClassName("sub-menu-list")[1]
                            .querySelector(".sub-title")
                            .classList.add("f-c-red");
                    } else {
                        document
                            .getElementsByClassName("sub-menu-list")[1]
                            .querySelector(".sub-title")
                            .classList.remove("f-c-red");
                    }
                }
            },
            back() {
                this.$router.push({name: "dashboard"});
            },
            async init() {
                await this.getAfiliasi("loadAll");
            },
            copyLink() {
                let referalLink = document.getElementById("referal_link");
                referalLink.setAttribute("type", "text");
                referalLink.select();

                try {
                    let successful = document.execCommand("copy");
                    let msg = successful ? "successful" : "unsuccessful";
                    this.$toast.success(msg);
                } catch (e) {
                    this.$toast.error(e);
                }

                referalLink.setAttribute("type", "hidden");
                window.getSelection().removeAllRanges();
                this.smartTrackingClick("salin_link_afiliasi");

            },
            shareLink() {
                let referalLink = this.referalLink;

                //location.replace(`https://wa.me/?text=Ayo daftarkan laundrymu di ${referalLink} sekarang juga`);
                window.open(`https://wa.me/?text=Ayo daftarkan laundrymu di ${referalLink} sekarang juga`, '_blank');
                this.smartTrackingClick("share_link_afiliasi");
            },
            doWithdraw() {
                this.$router.push({name: "afiliasi.dashboard.withdraw"});
                this.smartTrackingClick("afiliasi_add_tarik_tunai");

            },
            linkToDetail(menu) {
                this.$router.push({name: menu.linkTo});
                this.smartTrackingClick('afiliasi_'+menu.title.replaceAll(" ","_").toLowerCase());
            },
            setFormReady(val) {
                this.formReady = val;
            },
        },
    };
</script>
<style scoped src="../styleScope.css"></style>

<style scoped>
    .separator {
        width: auto;
    }

    .referal-link label {
        margin-top: 8px;
        margin-bottom: 8px;
    }

    .referal-link div.link {
        width: 100%;
        background: #edf5ff;
        padding-left: 12px;
        padding-right: 12px;
        height: 37px;
        border: 1px dashed #a8c6ff;
        box-sizing: border-box;
        border-radius: 4px;
    }

    .referal-link div.link label {
        margin-left: 8px;
    }

    .referal-link .actions-link {
        column-gap: 10px;
    }

    .referal-link .actions-link div {
        width: 44vw;
    }

    .sub-menu-list .menu-separator {
        border-bottom: 1px solid #ededed;
    }

    .sub-menu-list:nth-last-child(1) .menu-separator {
        border-bottom: unset;
    }

    @media (min-width: 768px) {
        .referal-link .actions-link div {
            width: 39vw;
        }
    }
</style>
